import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const BottomGrid = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 3rem;

  @media screen and (max-width: ${layout.md}) {
    display: none;
  }
`;
